/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Speaker_HeaderInputs */

const en_speakers_metrics_speaker_header = /** @type {(inputs: Speakers_Metrics_Speaker_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

const fr_speakers_metrics_speaker_header = /** @type {(inputs: Speakers_Metrics_Speaker_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

const de_speakers_metrics_speaker_header = /** @type {(inputs: Speakers_Metrics_Speaker_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

const it_speakers_metrics_speaker_header = /** @type {(inputs: Speakers_Metrics_Speaker_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

const ru_speakers_metrics_speaker_header = /** @type {(inputs: Speakers_Metrics_Speaker_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

const es_speakers_metrics_speaker_header = /** @type {(inputs: Speakers_Metrics_Speaker_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

const zh_cn2_speakers_metrics_speaker_header = /** @type {(inputs: Speakers_Metrics_Speaker_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

const ja_speakers_metrics_speaker_header = /** @type {(inputs: Speakers_Metrics_Speaker_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

const hi_speakers_metrics_speaker_header = /** @type {(inputs: Speakers_Metrics_Speaker_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

const pt_pt2_speakers_metrics_speaker_header = /** @type {(inputs: Speakers_Metrics_Speaker_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speakers`)
};

/**
* | output |
* | --- |
* | "Speakers" |
*
* @param {Speakers_Metrics_Speaker_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_speaker_header = /** @type {((inputs?: Speakers_Metrics_Speaker_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Speaker_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_metrics_speaker_header(inputs)
	if (locale === "de") return de_speakers_metrics_speaker_header(inputs)
	if (locale === "it") return it_speakers_metrics_speaker_header(inputs)
	if (locale === "ru") return ru_speakers_metrics_speaker_header(inputs)
	if (locale === "es") return es_speakers_metrics_speaker_header(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_metrics_speaker_header(inputs)
	if (locale === "ja") return ja_speakers_metrics_speaker_header(inputs)
	if (locale === "hi") return hi_speakers_metrics_speaker_header(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_metrics_speaker_header(inputs)
	return en_speakers_metrics_speaker_header(inputs)
});